import { withInstall } from '@jdesign-vue/utils'

import Divider from './src/divider.vue'

export const JdDivider = withInstall(Divider)
export default JdDivider

export * from './src/divider'
